import React from "react";
import './condiciones.css';
import {getbyID} from "../../modules/datafunction";
import {condiciones} from "../../modules/data";
import {container,card} from "../../modules/primecompo";

const getitem0=()=>{
    const cdata=getbyID({item:0},condiciones)
    const content0=<div>
            <h1>{cdata['title']} </h1>
        </div>;
    const content1=
        <div>
           {cdata['p'].map((item,index)=>( 
                <p key={index}>{item}</p>
            ))} 
        </div>;  
    return(card(content0,content1,"row0","row0"))
}
const getitem1=()=>{
    const cdata=getbyID({item:1},condiciones)
    const content0=
        <div>
              <p> <span>{cdata['span']}</span> {cdata['p'][0]} </p>
              <p>{cdata['p'][1]}</p>
      </div>
    return(container(content0,"row0"))      
}
const getitem2=()=>{
    const cdata=getbyID({item:2},condiciones)
    const content0=<p>
             <span> {cdata['Servicio']} </span> 
             {cdata['p']}   
            </p>
    const content1=<ul>
        {cdata['li'].map((item,index)=>( 
            <li key={index}>{item}</li>
        ))}
    </ul>
    return(container([content0,content1],"row0"))  
}
const getitem3=()=>{
const cdata=getbyID({item:3},condiciones)
const content0=
    <div>
        {cdata['span'].map((item,index)=>{

            <p>
                <span key={index}>{item}</span>
                {cdata['p'][index]}
            </p>

        })}
    </div>

return(container(content0,"row0"))
}
const getitem4=()=>{
    const cdata=getbyID({item:4},condiciones)
    const content0=
    <p> <span> {cdata['span']} </span> {cdata['p'][0]} </p>
    const content1=
    <p> {cdata['p'][1]}</p>
    return(container([content0,content1],"row0"))
}
const getitem5=()=>{
    const cdata=getbyID({item:5},condiciones)
    const content0=
    cdata['span'].map((item,index)=>(
        <p key={index}>
            <span>{item}</span>
            {cdata['p'][index]}
        </p>
      ))
    return(container(content0,"row0"))
}
const getitem6=()=>{
    const cdata=getbyID({item:6},condiciones)
    const content0=<p> <span> {cdata['span']} </span> {cdata['p'][0]} </p>
    const content1 = <div>
        {cdata['p'].map((item, index) => (
            <p key={index + 1}>{item}</p>
        ))}
    </div>
    return(container([content0,content1],"row0"))
}
const getitem7=()=>{
    const cdata=getbyID({item:7},condiciones)
    const content0=
    <p> <span> {cdata['span']} </span> {cdata['p'][0]} </p>
    const content1=
    <ul>
        {cdata['li'].map((item,index)=>( 
            <li key={index}>{item}</li>
        ))}
    </ul>
    return(container([content0,content1],"row0"))
}
const getitem8=()=>{
    const cdata=getbyID({item:8},condiciones)
    const content0=
    <p> <span> {cdata['span']} </span> {cdata['p']} </p>
    const content1=
    <ul>
        {cdata['li'].map((item,index)=>( 
            <li key={index}>{item}</li>
        ))}
    </ul>
    return(container([content0,content1],"row0"))

}
const getitem9=()=>{
    const cdata=getbyID({item:9},condiciones)
    const content0=
    <p> <span> {cdata['span']} </span> {cdata['p']} </p>
    return(container(content0,"row0"))
}
const Condiciones=()=>{
    return(
        <div className="condiciones"> 
            {getitem0()}
            {getitem1()}
            {getitem2()}
            {getitem3()}
            {getitem4()}
            {getitem5()}
            {getitem6()}
            {getitem7()}
            {getitem8()}
            {getitem9()}
        </div>
    )
}
export {Condiciones}